<template>
  <div class="cashierdiaryTable" :id = "dataRow&&dataRow.id?dataRow.id:'cashierdiaryTable'">
    <div class="ct_wrapper">
      <div class='ct_wrapper-table'>
        <!-- 头部 -->
        <div class="ct_wrapper-table-header">
            <span class="ct_wrapper-table-header-title" >{{ c_title }}</span>
            <!-- 快捷键 -->
            <shortcut-key-tip></shortcut-key-tip>
            <!-- 编号 -->
            <div class="ct_wrapper-table-header-number" v-if="nowSaveParams.id&&nowTabVal!=3&&nowSaveParams.number">
              <div class="flex_wrapper">
                 <!-- <i class="ct_wrapper-table-header-number-left"></i> -->
                 <span class="ct_wrapper-table-header-number-center">NO.{{ nowSaveParams.number }}</span>
                 <!-- <i class="ct_wrapper-table-header-number-right"></i> -->
              </div>
            </div>
             <!-- 修改时关闭 -->
            <i
              class="el-icon-close ct_wrapper-table-header-close"
              v-if="isEdit"
              @click="$emit('close',true)"
            ></i>
          </div>
         <!-- 表格 -->
        <div
          class="ct_wrapper-table-content"
          v-loading="tableLoading"
          :style="{ boxShadow:isEdit?'none':'' }"
        >
          <div class="ct_wrapper-table-content-tab">
            <!-- tab选项组件 -->
            <table-tab
              :list="tabList"
              ref="tableTabs"
              :beforLeave = "beforTabLeave"
              :nowTabVal="nowTabVal"
            >
            </table-tab>
          </div>
          <div class="ct_wrapper-table-publicPadding" >
            <!-- 表格剥离属性 -->
            <div class="ct_wrapper-table-content-select flex_wrapper">
              <!-- 日期属性 -->
              <date-time @change="handleDateChange" ref="dateTimeRef"></date-time>
              <!-- 内部转账账户工具 -->
              <transfer-accounts-select
                :list="allAccountList"
                ref="transferRef"
                v-if="nowTabVal==3"
              >
              </transfer-accounts-select>
            </div>
            <!-- 正式表格主体 -->
            <div class="ct_wrapper-table-content-main">
              <el-row
                class="ct_wrapper-table-content-main-row"
                v-for="(tr,indexs) in markNumberArr"
                :style="{'borderColor':indexs===1?'#666':'#ccc'}"
                :key="indexs"
              >
                <el-col
                  v-for="(td,index) in tr"
                  class="ct_wrapper-table-content-main-row-td"
                  :key="td.id"
                  :span="(td.isRow)?24:12"
                >
                  <div
                    class="ct_wrapper-table-content-main-row-td-label"
                    :style="{
                      'borderLeft':td.cancalBorder?'none':'1px solid #ccc',
                    }"
                  >
                    <span class="ct_wrapper-table-content-main-row-td-label-isStuff" v-if="td.isStuff">*</span>
                    <span class="ct_wrapper-table-content-main-row-td-label-text">{{td.columnName}}</span>
                  </div>
                  <div class="ct_wrapper-table-content-main-row-td-value">
                    <!-- 文本框输入 -->
                    <c-text
                      :ref="'ref' + td.id"
                      v-model="td.value"
                      v-if="td.customType=='1'"
                      @textFocus="textFocus"
                      :td="td"
                    ></c-text>
                    <!-- 数值输入 -->
                    <c-number
                      :ref="'ref' + td.id"
                      :tableList="markNumberArr"
                      :tdItem = 'td'
                      v-model="td.value"
                      v-if="td.customType=='3'"
                    ></c-number>
                    <!-- 下拉框 -->
                    <c-select
                      :ref="'ref' + td.id"
                      v-model="td.value"
                      :optionList="td.optionList"
                      v-if="td.customType=='4'"
                      @change="handleTableChange"
                      @addSelectOption = "addSelectOption($event,td)"
                      :multiple="td.isChoice===1"
                      :inputTip="'请选择' + td.columnName"
                    ></c-select>
                    <!-- 日期组件 -->
                    <c-date
                      :ref="'ref' + td.id"
                      v-model="td.value"
                      v-if="td.customType=='2'"
                      :inputTip="'请选择' + td.columnName + '日期'"
                    >
                    </c-date>
                    <!-- 图片 -->
                    <c-upload
                      :ref="'ref' + td.id"
                      v-if="td.customType=='5'"
                      :imgList="td.imgList?td.imgList:[]"
                      @getImgList = "getImgList($event,td)"
                    >
                    </c-upload>
                    <!-- 按钮 -->
                    <c-btn
                      v-if="td.customType=='6'"
                      :ref="'ref' + td.id"
                      :data="td"
                      @getBtnList = "getBtnList($event,td)"
                    >
                    </c-btn>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- footer -->
            <div class="ct_wrapper-table-content-footer flex_wrapper">
              <span>制单人：{{userName}}</span>
              <span v-if="tableList.length">
                本次{{tableList[1].columnName}}：
                <span class="ct_wrapper-table-content-footer-num">{{currencys(tableList[1].value?tableList[1].value:0)}}</span>
                <span class="ct_wrapper-table-content-footer-unit">元</span>
              </span>
            </div>
          </div>
        </div>
         <!-- 按钮组 -->
        <div class='ct_wrapper-table-btnGroup'>
          <template v-for="btn in btnGroupList">
            <acc-btn
              :text="btn.name"
              :type="btn.type"
              v-if="btn.show"
              @click="handleOperation(btn)"
              :key="btn.id"
              :icon="btn.icon"
            >
            </acc-btn>
          </template>
        </div>
      </div>
      <!-- 操作面板 -->
      <div class="ct_wrapper-panel" v-if="!isEdit&&nowTabVal!=3">
        <c-panel @handleClick="handlePanelClick"></c-panel>
      </div>
    </div>
    <!-- 新增&&修改日记账弹框 -->
    <add-c-dialog
      ref="cashierdiaryDialog"
      :row="editData"
      :title="d_titile"
      @closeKeyWatch="closeKeyWatch"
      @openKeyWatch="openKeyWatch"
      @handleSuccess="handleAddSuccess"
    >
    </add-c-dialog>
    <!-- 编辑字段  && 禁用、排序   -->
    <edit-c-dialog
      ref="cashierdiaryEditDialog"
      :useList = "userCustomList"
      @closeKeyWatch="closeKeyWatch"
      @openKeyWatch="openKeyWatch"
      @getCustomItem="getUserCustomList"
      @editField="editField"
    >
    </edit-c-dialog>
    <!-- 模板 -->
    <c-template
      ref="cTemplateRef"
      :list='templateList'
      @useTemplate="useTemplate"
      @delTemplate="delTemplate"
      :getTemplate="getTem"
      :isNotSave="!nowSaveParams.id"
      @saveTemplate="saveTemplate"
      @closeKeyWatch="closeKeyWatch"
      @openKeyWatch="openKeyWatch"
    >
    </c-template>
    <!-- 微信配置 -->
    <we-chart-push
      :allData = "allData"
      ref = "weChartRef"
      @closeKeyWatch="closeKeyWatch"
      @openKeyWatch="openKeyWatch"
    >
    </we-chart-push>
    <!-- 新增下拉选项 -->
    <c-add-option
      @closeKeyWatch="closeKeyWatch"
      @openKeyWatch="openKeyWatch"
      @add = "handleAddSelectOption"
      :title = "nowAddSelect.columnName"
      :loading = "addOptionLoading"
      ref = "addOptionRef"
    ></c-add-option>
  </div>
</template>

<script>
  import components from "./components.js"
  import {currencys} from '@/assets/utils/currencyFormat'
  export default {
    components,
    props:{
      c_title:{
        type:String,
        default:"新增日记账"
      },
      isEdit:[Boolean],
      dataRow:[Object]
    },
    data() {
      return {
        currencys,
        allAccountList:[],  // 所有账户
        templateList:[],
        d_titile:'新增字段',
        editData:{},  // 编辑字段数据
        userCustomList:[],  // 用户自定义列表
        allData:[],
        insideAccountList:[  // 内部转账列表
          {
            columnName:"摘要",
            id:1,
            customType:"1",
            type:1,
            isRow:true,
            fillRule:0,
            value:"",
            props:"summary",
          },
          {
            columnName:"转出金额",
            id:2,
            fillRule:1,
            type:2,
            props:"money",
            customType:"3",
            isRow:true,
            value:""
          }
        ],
        markNumberArr_copy:[],  //表格初始化数据，用于清空覆盖
        tableLoading:false,
        btnGroupList:[
          {
            name:"模板",
            id:1,
            type:'4',
            show:true,
            icon:"/static/icon/c_template.png"
          },
          {
            name:"打印",
            id:2,
            type:'4',
            show:true,
            icon:"/static/icon/c_export.png"
          },
          {
            name:"保存",
            id:3,
            type:'1',
            show:true,
            icon:"/static/icon/c_save.png"
          },
          {
            name:"保存并新增",
            id:4,
            type:'1',
            show:true,
            icon:"/static/icon/c_add.png"
          },
          {
            name:"新增",
            id:5,
            type:'1',
            show:false,
            icon:"/static/icon/c_add.png"
          }

        ],
        baseTableList:[
          {
            columnName:"摘要",
            id:1,
            customType:"1",
            isRow:true,
            fillRule:0,
            value:"",
            props:"summary",
            fixed:true,
            isStuff:1
          },
          {
            columnName:"收入",
            id:2,
            fillRule:1,
            customType:"3",
            isRow:false,
            props:"debitMoney",
            value:"",
            fixed:true,
            isStuff:1
          },{
            columnName:"支出",
            id:3,
            fillRule:2,
            customType:"3",
            isRow:false,
            value:"",
            isStuff:1,
            fixed:true,
            props:"creditorMoney",
          },{
            columnName:"账户",
            id:4,
            customType:"4",
            fillRule:0,
            isRow:false,
            isChoice:0,
            value:"",
            isStuff:1,
            optionList:[],
            fixed:true,
            props:"fkJournalAccountId",
          }
        ],
        nowTabVal:'1', //当前选择tab，默认收入
        tableList:[],
        isEditTable:false,   // 当前表格是否修改
        nowSaveParams:{}, //当前保存成功参数
        tabList:[
          {
            label:"收入",
            name:"1",
            disabled:false
          },
          {
            label:"支出",
            name:"2",
            disabled:false
          },
          {
            label:"内部转账",
            name:"3",
            disabled:false
          }
        ],
        markNumberArr:[],  //占位数组  当长度等于2的时候表示换行  下一行第一个需消除左边border
        userChangeDate:null,  // 日记账时间
        editDataRow:{},  // 当前修改数据
        nowEditItem:null, // 当前聚焦项
        nowAddSelect:{},  // 当前新增下拉
        addOptionLoading: false, // 新增下拉框loading
      }
    },
    created() {
      // 初始化当前时间
      let nowDate = new Date();
      this.userChangeDate = this.$util.formatDate.format(nowDate,'yyyy-MM-dd');
    },
    computed:{
      userName() {
      	return this.$getSessionStorage('userMssage_name');
      },
    },
    mounted() {

    },
    activated() {
      this.openKeyWatch();
    },
    deactivated() {
      this.closeKeyWatch();
    },
    watch:{
      markNumberArr:{
        handler(data) {
          this.isEditTable = true;
        },
        deep:true,
      },
      dataRow:{   //d 监听修改
        handler(data) {
          if(data&&data.id) {
            this.nowSaveParams.id = data.id;
            this.nowSaveParams.number = data.number;
            this.nowTabVal = data.transfer?(data.transfer + ""):'3';
            this.editDataRow = data;

            // 禁用tab
            this.tabList.forEach((i,index)=>{
              i.disabled = false;
              if(this.nowTabVal==3&&index<2) {
                i.disabled = true;
              }if(this.nowTabVal!=3 && index==2) {
                i.disabled = true;
              }
            })
            this.getAllAccount(); // 查询所有账户
          }else {
            this.editDataRow = {};
            this.nowSaveParams = {};
            if(data.mark) {
              this.getAllAccount(); // 查询所有账户
            }
          }

        },
        immediate:true
      }
    },
    methods:{
      /**
       * @description: 下拉框新增选项 --接口调用
       * @param {Array} data 子组件传过来的新增数据
       * @return {*}
       * @author: jinchuan.lee
       */      
      handleAddSelectOption(data) {
        let existData = this.nowAddSelect.optionList.map(i=> i.optionName),
        isColor = this.nowAddSelect.optionList.some(i => i.color),
        addDataList = [];
          // 如果现有的存在，则不能添加
        for(var i = 0 ; i < existData.length ; i++) {
          for(var x = 0 ; x < data.length ; x++) {
            if(existData[i] == data[x]) {
              data.splice(x,1)
            }
          }
        }
        data.forEach((i,index)=>{
          if(i) {
            addDataList.push({
              optionName: i,
              color: isColor?this.randomColor():"",
              isDefault:false
            })
          }
        })
        this.requestSaveOption(addDataList);
        
      },
      // 随机颜色函数
      randomColor(){
        let r,g,b,a;
        r = Math.floor(Math.random()*256);
        g = Math.floor(Math.random()*256);
        b = Math.floor(Math.random()*256);
        a = 0.8;
        return 'rgba(' + r +',' + g + ',' + b + ',' + a +")";
      },
      /**
       * @description: 保存下拉选项
       * @param {*} arr 最终保存的数据
       * @return {*}
       * @author: jinchuan.lee
       */      
      requestSaveOption(arr) {
        let arrList = this.$lodash.cloneDeep(arr);
          arrList.forEach(i => {
            i.isDefault = i.isDefault?1:0;
            i.customColumnId = this.nowAddSelect.id;
          })
          let params = {
            list:arrList,
          }
          this.addOptionLoading = true;
          this.$http.post('custom/saveOptin' , params).then(res=>{
            this.addOptionLoading = false;
       			if(res&&res.data.code == 1) {
               this.$message.success("操作成功！");
               this.handleAddSuccess();
               this.$refs.addOptionRef.dialogVisible = false;
       			}
       		})
      },
      /**
       * @description: 下拉框新增选项
       * @param {*} e Boolean 子组件传参  暂时没用
       * @param {*} td  当前点击td
       * @return {*}
       * @author: jinchuan.lee
       */      
      addSelectOption(e,td) {
        if(td.id == '4') {  // 账户添加选项直接跳转
          this.$router.push({ path:"./cashieraccount" })
          return 
        }
        this.nowAddSelect = td;
        this.$refs.addOptionRef.dialogVisible = true;
      },
      /*
      *tab点击事件
      * @param type String;
      * 1、收入
      * 2、支出
      * 3、内部转账
      * */
      tabClick(type) {
        this.nowTabVal = type;
        this.nowEditItem = null;
        this.getTableContent();
        this.btnShowRule();
      },
      // tab点击判断是否有修改并提示
      beforTabLeave(e) {
        if(e == this.nowTabVal) return true;
        let prevent = false;
        let formText = this.nowTabVal=='1'?"收入":this.nowTabVal=='2'?"支出":this.nowTabVal=='3'?"内部转账":"";
        let toText = e=='1'?"收入":e=='2'?"支出":e=='3'?"内部转账":"";
        // console.log(formText,toText)
        if(this.nowSaveParams.id) {  // 当前是修改状态
          //修改状态收支不能和内部转换互相切换  反之亦然
          if(this.nowTabVal == '3') {   // 内部转账
            this.$message.warning(formText +　"不能切换为" + toText);
          }else if(e == '3'){  // 切换到内部转账
            this.$message.warning(formText + "不能切换为" + toText);
          }else {  // 收支互相切换
            this.$confirm(`是否修改为${toText}，保存时将清除已填写的${formText}数据`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.tabClick(e);
              prevent = true;
            })
          }
        }else if(this.isEditTable){  // 新增状态并且有修改
          this.$confirm(`是否切换为${toText}，保存时将清除已填写的${formText}数据`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.tabClick(e);
            prevent = true;
          })
        }else {
          this.tabClick(e);
          prevent = true;
        }
        return prevent;
      },
      // 弹框开启时关闭全局键盘监听
      closeKeyWatch() {
        window.removeEventListener('keydown',this.quickKey)
      },
      // 弹框关闭时开启全局键盘监听
      openKeyWatch() {
        window.addEventListener('keydown',this.quickKey)
      },
      // 快捷键处理
      quickKey(e) {
        //console.log(e.keyCode)
        let keyCode = e.keyCode || e.which || e.charCode;
        switch(keyCode) {
          case 123:  // F12 保存并新增  如果此时是保存状态  则无效
            if(this.nowSaveParams.id) {
              this.$message.warning("系统未检测到保存并新增功能！")
            }else {
              this.saveCashierdiary('clear');
            }
             e.preventDefault();
            break;
          case 120:  // F9  新增
            if(this.nowSaveParams.id) {
              this.handleAddTable();
            }else {
              this.$message.warning("系统未检测到新增功能！")
            }
            e.preventDefault();
            break;
          case 83:  // s 如果此时按住了 ctrl则执行保存
            if(e.ctrlKey) {
               this.saveCashierdiary();
               e.preventDefault();
            }
            break;
          case 97:
          case 49: // 1 如果此时按住了 ctrl则执行跳转收入
            if(e.ctrlKey&&this.nowTabVal!==1) {
              this.tabClick("1");
               e.preventDefault();
            }
            break;
          case 98:
          case 50: // 2 如果此时按住了 ctrl则执行跳转支出
            if(e.ctrlKey&&this.nowTabVal!==2) {
              this.tabClick("2");
              e.preventDefault();
            }
            break;
          case 99:
          case 51: // 3 如果此时按住了 ctrl则执行跳转内部转账
            if(e.ctrlKey&&this.nowTabVal!==3) {
              this.tabClick("3");
              e.preventDefault();
            }
            break;
          case 13:  // enter  进来就按enter则锁定第一个框
            this.enterJump();
            e.preventDefault();
            break;
        }
      },
      // enter 跳下一个
      enterJump() {
        let nowItem = this.nowEditItem;
        // console.log(nowItem)
        if(nowItem && nowItem.id) { // 如果有nowItem  跳转nowItem的下一个
          this.tableList.forEach((i,index)=>{
            if(nowItem.id === i.id) {
              this.focusItem(i.id,false);  // 当前失去焦点
              this.getNextItem(index+1);
            }
          })
        }else {  // 如果没有nowItem  默认跳转第一个
          this.nowEditItem = this.tableList[0];
          this.focusItem(this.nowEditItem.id,true);
        }
      },
      // 递归获取下一个item 必须是  文本框  数值  下拉  日期中的一个  如果都没有则回到开头
      getNextItem(index) {
        if(index > this.tableList.length - 1) {
          this.focusItem(this.tableList[0].id,true);
          this.nowEditItem = this.tableList[0];
        }else {
          let nextItem = this.tableList[index],
          isNext = (nextItem.customType == 1 || nextItem.customType == 2 || (nextItem.customType == 3&&!nextItem.valueType) || nextItem.customType == 4);
          if(isNext) {  // 下一个是其中的一个  则赋值  并聚焦到下一个
            this.nowEditItem = nextItem;
            this.focusItem(nextItem.id,true);
          }else {  // 不是则继续找
            this.getNextItem(index+1);
          }
        }
      },
      // 聚焦项目 && 失去项目焦点
      focusItem(id,type) {
        let refText = 'ref' + id;
        if(type) {
          this.$refs[refText][0].$children[0].focus();
          if(this.$refs[refText][0].$children[0].select) this.$refs[refText][0].$children[0].select();
        }else {
          this.$refs[refText][0].$children[0].blur()
        }
        // console.log(this.$refs[refText][0].$children[0])
      },
      // 项目手动聚焦
      textFocus(td) {
        this.nowEditItem = td;
      },
      // 使用模板判断
      useTemplate(data) {
        console.log(this.nowSaveParams)
        if(this.nowSaveParams.id) {  // 覆盖已有模板
          this.$confirm('当前日记账已有内容，是否覆盖？', '提示', {
            confirmButtonText: '覆盖',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.useTemplates(data);
          })
        }else {
          this.useTemplates(data);
        }
      },
      // 使用模板
      useTemplates(data) {
        this.userChangeDate = this.$util.formatDate.format(data.date,'yyyy-MM-dd');
        this.$refs.cTemplateRef.templateModal = false;
        this.$refs.dateTimeRef.setValue(data.date);
        // console.log('使用模板：'+data.summary)
        let dataOne = data.summary;
        let dataTwo = this.allData;
        // 对比踢出已经被禁用的模板
        for(var i = 0;i<dataOne.length;i++) {
          for(var j = 0;j<dataTwo.length;j++) {
            if(dataOne[i].id === dataTwo[j].id) {
              if((dataTwo[j].customType==4 || dataTwo[j].customType==6)&&dataTwo[j].isChoice==1) {  // 多选
                dataTwo[j].value = dataOne[i].value;
                dataTwo[j].optionListValue = dataOne[i].value;
              }else {
                dataTwo[j].value =  dataOne[i].value;
                dataTwo[j].imgList =  dataOne[i].imgList;
              }
            }
          }
        }
        // 重新动态计算
       this.changeTableHeight(10);
      },
      // 删除模板
      delTemplate(data) {
        this.$confirm(`是否删除模板${data.templateName}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let childRef =  this.$refs.cTemplateRef;
          childRef.temLoading = true;
          this.$http.post('journal/deleteTemplate',{id:data.id}).then(res=>{
            childRef.temLoading = false;
            if(res && res.data.code == '1'){
              this.getTem();
              this.$message.success("删除成功！")
            }
          })
        })
      },
      // 获取自定义模板
      getTem(){
        this.templateList = [];
        let childRef =  this.$refs.cTemplateRef;
         childRef.temLoading = true;
        this.$http.post('journal/getTemplate',{type:Number(this.nowTabVal)}).then(res=>{
          childRef.temLoading = false;
          if(res && res.data.code == '1'){
            this.templateList = res.data.data.map(i=>{
              i.summary = JSON.parse(i.summary)
              i.date = this.$util.formatDate.format(i.date,'yyyy-MM-dd');
              return i;
            });
          }
        })
      },
      // 保存模板
      saveTemplate(data) {
        let childRef =  this.$refs.cTemplateRef;
        let tableData = this.$lodash.cloneDeep(this.markNumberArr),saveArr = [];
          tableData.forEach(arr=>{
            arr.forEach(i=>{
              if((i.id==2 || i.id == 3)&&!data.savingAmount) {
                i.value = "";
              }
              saveArr.push(i)
            })
          })
        childRef.temLoading = true;
        let params = {
          summary:JSON.stringify(saveArr),
          date:this.userChangeDate,
          directionType: Number(this.nowTabVal),
          templateName:data.templateName,
          savingAmount:data.savingAmount?1:0,
        }
        this.$http.post('journal/savaTemplate',params).then(res=>{
          if(res && res.data.code == '1'){
             childRef.temLoading = false;
             this.getTem();
            this.$message.success("保存模板成功！")
          }
        }).catch(e=>{

        });
      },
      // 获取按钮类型
      getBtnList(e,td) {
        let choiceData = e.filter(i=>{ return i.isDefault })
        //console.log(choiceData)
        if(choiceData.length) {
          td.value = td.isChoice==1?[]:"";
          choiceData.forEach(i=>{
            if(td.isChoice==1) {  // 多选
              td.value.push(i.id);
            }else {
              td.value = i.id;
            }
          })
        }else {
          td.value = "";
        }
      },
      // 修改字段
      editField(row) {
        this.d_titile = '编辑字段';
        this.$refs.cashierdiaryDialog.dialogVisible = true;
        this.editData = row;
      },
      // 表格操作面板点击
      handlePanelClick(data) {
        switch(data.iconName) {
          case "c-add-field":  // 新增字段
            this.d_titile = '新增字段';
            this.$refs.cashierdiaryDialog.dialogVisible = true;
            this.editData = {};
            break;
          case "c-edit-field":  // 编辑字段
            this.$refs.cashierdiaryEditDialog.dialogVisible = true;
            break;
          case "c-push-wx":  // 微信推送
            this.$refs.weChartRef.dialogVisible = true;
            this.$refs.weChartRef.setList(this.allData);
            break;
        }
      },
      // 时间改变 默认当天时间  修改后重新赋值
      handleDateChange(e) {
        this.userChangeDate = e;
      },
     // 下拉框改变
     handleTableChange(e) {
        this.changeTableHeight(10);
     },
    // 延迟改变样式
    changeTableHeight(delay) {
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.getTableTdHeight();
        },delay)
      })
    },
	  // 查询所有账户
	  getAllAccount(){
	    this.$http.post('journal/findAccount',{type:-1}).then(res=>{
	      if(res && res.data.code == '1'){
          this.allAccountList = this.$lodash.cloneDeep(res.data.data);
          this.baseTableList[3].optionList = res.data.data.map(i=>{
            i.optionName = i.name;
            return i;
          });
          this.getUserCustomList();  // 请求自定义项目
	      }
	    }).catch(e=>{

	    });
	  },
		// 赋值图片项
      getImgList(e,td) {
        td.imgList = e;
        this.changeTableHeight(500);  // 触发样式改变
      },
      /*
      * 按钮组点击
      * @ljc 2021/04/26
      **/
      handleOperation(item){
        //console.log(item)
        if(item.id===3) {  // 保存
          this.saveCashierdiary();
        }else if(item.id === 1) {  // 模板设置
          this.$refs.cTemplateRef.templateModal = true;
        }else if(item.id === 2) {  // 打印
          this.Printing();
        }else if(item.id === 4) {
           this.saveCashierdiary('clear');
        }else if(item.id === 5) {  // 新增
           this.handleAddTable();
        }
      },
      // 新增函数
      handleAddTable() {
        if(this.isEditTable) {  // 如果表格修改
          this.$confirm('系统检测到日记账已修改，是否放弃当前修改？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.nowSaveParams = {};
            this.clearTbale(this.markNumberArr_copy);
          })
        }else {
         this.nowSaveParams = {};
         this.clearTbale(this.markNumberArr_copy);
        }
      },
      // 打印当前以保存日记账
      Printing() {
        if(!this.nowSaveParams.id) return;
        const router = this.$router.resolve({
          path: '/createPDF/printDiaryById',
          query: {
            transfer:Number(this.nowTabVal),
            journalId:this.nowSaveParams.id,
            cid: sessionStorage.cid,
            token: sessionStorage.token,
          }
        })
        window.open(this.$rootUrl + router.href, '_blank');
      },
      // 清空当前日记账页面
      clearTbale(arr) {
        this.allData = this.$lodash.cloneDeep(arr);
        this.getTableContent();
        this.btnShowRule();
      },
      // 按钮显示规则控制
      btnShowRule() {
        if(this.isEdit) {
          this.btnGroupList[1].show = false;  // 打印
          this.btnGroupList[0].show = false;  // 模板
          this.btnGroupList[3].show = false;  // 保存并新增
          this.btnGroupList[4].show = false;  // 新增
        }else {
          if(this.nowSaveParams.id) {
            this.btnGroupList[4].show = true;  // 新增
            this.btnGroupList[3].show = false;  // 保存并新增
            if(this.nowTabVal == 3) {  // 内部转账没有模板和打印
              this.btnGroupList[1].show = false;  // 打印
              this.btnGroupList[0].show = false;  // 模板
            }else {
              this.btnGroupList[1].show = true;  // 打印
              this.btnGroupList[0].show = true;  // 模板
            }


          }else {
            // 新增清空重置tab
            this.tabList.forEach(i=>{
              i.disabled = false;
            })
            this.btnGroupList[1].show = false;  // 打印
            this.btnGroupList[0].show = true;  // 模板
            this.btnGroupList[3].show = true;  // 保存并新增
            this.btnGroupList[4].show = false;  // 新增
          }
        }
        //this.btnGroupList[0].show = false;  // 模板
      },
      // 保存内部转账
      saveTransferAccounts(status) {
        let transferDom = this.$refs.transferRef;
        let accountData = transferDom.form , num = this.markNumberArr[1][0].value;
        if(!accountData.account1 || !accountData.account2) {  //判断账户
          return this.$message.warning("请选择双方账户！")
        }
        if(!this.markNumberArr[0][0].value) {  //判断摘要
           return this.$message.warning("请输入摘要！")
        }
        if(!Number(num) || num < 0) {  //判断摘要
           return this.$message.warning("请输入大于0的金额！")
        }
        // 开始保存************
        let params = {
          transferOutAccountId: accountData.account1, // 转出账户
          transferIntoAccountId: accountData.account2, // 转入账户
          date: this.userChangeDate, // 日期
          money: this.markNumberArr[1][0].value, // 金额
          summary: this.markNumberArr[0][0].value, // 摘要
        }
        this.tableLoading = true;
        if(this.nowSaveParams.uId) { params.uId = this.nowSaveParams.uId}
        this.$http.post('journal/internalTransfer' , params).then(res=>{
          this.tableLoading = false;
          if(res&&res.data.code==1) {
            if(status === "clear") {  // 保存并新增
               this.nowSaveParams = {};
               this.clearTbale(this.markNumberArr_copy);
               transferDom.clearForm();
            }else {
              this.nowSaveParams.uId = res.data.data.uId;
              this.nowSaveParams.id = res.data.data.uId;
              this.isEditTable = false;
            }
            this.$message.success("操作成功！")
            this.btnShowRule(); // 按钮显示规则
            this.$emit("successSave",true)  // 保存成功
          }
        })
      },
      /*
      * 保存日记账主函数
      * @ljc 2021/04/26
      **/
      saveCashierdiary(status) {
        if(this.nowTabVal==3) {  //如果当前选项为内部转账  则跳转保存内部转账函数
          this.saveTransferAccounts(status);
          return;
        }
        let AllData = this.deconstructionArr(this.markNumberArr);
        this.tableRegTest(
          AllData,
          ()=>{  // 成功函数
            let fixedArr = AllData.filter(i=>{ return i.fixed });  // 剥离固定项目  摘要、收入、支出、账户
            let userArr = this.$lodash.cloneDeep(AllData.filter(i=>{ return !i.fixed }));  // 用户自定义项
            let tipText = this.nowSaveParams.id?"修改成功!":"保存成功！";
            let params = {};
            userArr.forEach(i=>{
              if((i.customType==4 || i.customType==6)&&i.isChoice==1) {  // 多选赋值回来
                i.optionListValue = i.value;
                i.value = "";
              }
               i.optionList = [];
            })
            params.customColumnList = userArr;    // 日记账自定义列赋值
            params.date = this.userChangeDate;  // 日记账时间赋值
            // 固定项目赋值  tips:此处很坑  后期建议后端改为后端返回固定项目，而不是前端写死！
            fixedArr.forEach(i=>{  // 日记账固定项赋值
              params[i.props] = i.value;
            })


           // params.jsonStr = JSON.stringify(this.markNumberArr);
            console.log(params)
            // 开始保存 日记账
            this.tableLoading = true;
            if(this.nowSaveParams.id) { params.id = this.nowSaveParams.id };  // id赋值
            this.$http.post('journal/saveJournalPeriod' , params).then(res=>{
              this.tableLoading = false;
              if(res&&res.data.code==1) {
                if(status === "clear") {  // 保存并新增
                   this.nowSaveParams = {};
                   this.clearTbale(this.markNumberArr_copy);
                }else {  // 保存
                  params = Object.assign({},params,{
                    ...res.data.data
                  })
                  this.nowSaveParams = this.$lodash.cloneDeep(params);  // 保存当前请求参数
                  this.isEditTable = false;
                }
                this.$message.success(tipText)
                this.btnShowRule(); // 按钮显示规则

                this.$emit("successSave",true)  // 保存成功
              }
            })
          },
          (e,item)=>{  // 验证失败函数
            console.log(item)
            this.$message.warning(e);
          }
        );
      },
      /*
      * 表格验证函数
      * @params
      * list  待验证数组
      * resolve  成功通过回调函数
      * reject   失败回调函数
      **/
      tableRegTest(list,resolve,reject) {
        if(list&&list.length) {
          // 筛选必填项
          let stuffList = list.filter(i=>{ return i.isStuff });
          let isOk = true;
          for(var i = 0;i<stuffList.length;i++) {  // 检测必填
            if(!stuffList[i].value&&stuffList[i].value!==0 && stuffList[i].customType!=5) {  // 检测不能为空
              isOk = false;
              reject(stuffList[i].columnName + "不能为空！",stuffList[i]);
              break;
            }
            // 检测图片
            if(stuffList[i].customType==5&&!stuffList[i].imgList.length) {
              isOk = false;
              reject(stuffList[i].columnName + "必须上传图片!",stuffList[i]);
              break;
            }
          }
          for(var i = 0;i<list.length;i++) { // 检测数值只能填数值
            if(list[i].customType==3&&!Number(list[i].value)&&Number(list[i].value)!==0) {  // 检测数值只能输入数字
              isOk = false;
              reject(list[i].columnName + "只能是数字!",list[i]);
              break;
            }
          }
          if(isOk) {
            resolve();
          }
        }else {
          reject("网络错误！");
        }

      },
      // 处理表格数据并返回一维数组
      deconstructionArr(arr) {
        let newArr = [];
         for(var i=0;i<arr.length;i++) {
           for(var k=0;k<arr[i].length;k++) {
             newArr.push(arr[i][k]);
           }
         }
         return newArr;
      },
      // 新增字段成功回调函数
      handleAddSuccess(data) {
        this.getUserCustomList();
      },
      // 获取自定义项目
      getUserCustomList() {
        this.tableLoading = true;
        this.$http.post('custom/findCustomColumn' , {}).then(res=>{
          this.tableLoading = false;
        	if(res&&res.data.code == 1) {
        		let data = res.data.data.map(i=>{
              i.isRow = false;
              if((i.customType==4 || i.customType==6)&&i.isChoice==1) {  // 多选
                i.value = i.optionListValue;
              }
              return i;
            });
            this.userCustomList = this.$lodash.cloneDeep(data);
            this.allData = this.$lodash.cloneDeep(this.baseTableList.concat(data));
            this.markNumberArr_copy = this.$lodash.cloneDeep(this.allData);  // 复制一份 保存新增时覆盖
            this.getTableContent();
        	}
        },error=>{
          this.tableDataMark(0);  // 出错任然显示基础选项
        })
        this.btnShowRule(); // 按钮显示规则
      },
      // 计算表格显示内容
      getTableContent() {
        if(this.nowTabVal === "3") {  // 内部转账  额外请求接口
          let rowData = this.editDataRow;
          this.tableList = this.$lodash.cloneDeep(this.insideAccountList);
          this.nowSaveParams.uId = rowData.uId;
          if(rowData.id) {
            this.tableLoading = true;
            this.$http.post('journal/getTransferByuId' , {uid: rowData.uId}).then(res=>{
              this.tableLoading = false;
            	if(res&&res.data.code == 1) {
                let data = res.data.data;
                this.tableList.forEach(i=>{
                  i.value = data[i.props]
                })

                this.$nextTick(()=>{
                  this.$refs.transferRef.setAccount(data);  // 账户赋值
                  this.$refs.dateTimeRef.setValue(this.$formart(data.date,'yyyy-MM-dd'));  // 时间赋值
                })
            	}
              this.markNumberArr = [],  // 置空二维数组
              this.tableDataMark(0);
            })
          }else {
            this.markNumberArr = [],  // 置空二维数组
            this.tableDataMark(0);
          }


        }else {
          // 显示当前tab选项的字段
          let nowData = this.allData.filter(i=>{ return (i.fillRule == this.nowTabVal) || (i.fillRule===0) });
          this.tableList = nowData;
          // 如果是修改内容 editDataRow @transfer  内部转账0 收入1   支出2  其他3
          let rowData = this.editDataRow;
          let tableList = this.tableList;
          if(rowData.id) {
            let dataList=[];
            for(var i in rowData) {
               let is= i.split("-");
               if(is[0] === 'value'){
                    let obj=new Object();
                     obj.id= is[1];
                    if(rowData[i]&&rowData[i].id){
                      if(typeof(rowData[i].id) === "string"){
                          obj.value=rowData[i].id
                      }else {
                          obj.optionListValue=rowData[i].id
                      }
                    }else if(rowData[i].customType==5){
                      obj.imgList = rowData[i].imgList?rowData[i].imgList:[]
                    }else{
                      obj.value=rowData[i].value;
                    }
                    obj.customType = rowData[i].customType;
                     dataList.push(obj)
                }
            }
            rowData.customColumnList = dataList;
            for(var i=0;i<tableList.length;i++) {
              if(tableList[i].id == 1 || tableList[i].id == 2 || tableList[i].id == 3 || tableList[i].id == 4) {  // 固定项目
                let props = tableList[i].props;
                tableList[i].value = rowData[props];
              }
            	for(var k=0;k<rowData.customColumnList.length;k++) {
            		if(tableList[i].id===rowData.customColumnList[k].id) {
            			if(rowData.customColumnList[k].optionListValue) {
            				tableList[i].optionListValue = rowData.customColumnList[k].optionListValue;
                    tableList[i].value = rowData.customColumnList[k].optionListValue;
            			}else if(rowData.customColumnList[k].imgList){
            				tableList[i].imgList = rowData.customColumnList[k].imgList;
            			}else{
            				tableList[i].value = rowData.customColumnList[k].value;
            			}
            		}
            	}
            }
            this.$nextTick(()=>{
              this.$refs.dateTimeRef.setValue(rowData.date);  // 时间赋值
            })
          }
          this.markNumberArr = [],  // 置空二维数组
          this.tableDataMark(0);
        }
      },
      /*
       * 计算表格高度函数
       * */
      getTableTdHeight() {
        console.log("动态计算");
        let tableId = this.dataRow&&this.dataRow.id?this.dataRow.id:'cashierdiaryTable'; // 取动态id 修复修改时格式乱的问题
        let rootDom = document.getElementById(tableId);
        var domList = rootDom.getElementsByClassName('ct_wrapper-table-content-main-row-td-label');
        for(var i=0;i<domList.length;i++) {
          let maxHeight = 0;  // 定义表格最高的高度
          let pHeight = domList[i].parentNode.parentNode;
          if(pHeight.childNodes.length) {  // label 和  value 的高度  总是取最高的为标准
            for(var j = 0;j < pHeight.childNodes.length;j++) {
              let firstChildHeight = pHeight.childNodes[j].firstChild.getElementsByClassName('ct_wrapper-table-content-main-row-td-label-text')[0].clientHeight;
              let lastChildHeight = pHeight.childNodes[j].lastChild.clientHeight;  // 取表格value撑开高度
              maxHeight = firstChildHeight>maxHeight?firstChildHeight:maxHeight;
              if(lastChildHeight > maxHeight) {
                maxHeight = lastChildHeight;
              }else {
                pHeight.childNodes[j].lastChild.style.height = maxHeight + "px"
              }
            }
          }
         // console.log(maxHeight)
          domList[i].style.height = maxHeight + 'px';
        }
      },
     /*
     * 表格数据标记，消除第一条左边border
     * @param index Number;
     **/
     tableDataMark(index) {
       let obj = this.tableList[index];
       obj.cancalBorder = false;  // 赋值是否消除border
       if(obj.isRow) {  // 独占一行的项目始终消除左边框
         obj.cancalBorder = true;
         this.markNumberArr[index] = [obj];
       }else {
         let markarr = this.markNumberArr;
         let length = this.markNumberArr.length;
         if(markarr[length-1].length===2 || markarr[length-1][0].isRow) {
           obj.cancalBorder = true;
           this.markNumberArr[length]= [obj];
         }else {
           markarr[length-1] = markarr[length-1].concat([obj])
         }
       }
       if(index<this.tableList.length-1) {
         // console.log(this.markNumberArr,index)
         this.tableDataMark(index+1)
       }else {
         // 排除数组空余部分  数组重组
         let arr = [];
         this.markNumberArr.forEach(i=>{
           arr.push(i)
         })
         this.markNumberArr = arr;
         setTimeout(()=>{ this.isEditTable = false },500);  // 消除修改状态
         this.changeTableHeight(50);
       }
     },

    }
  }
</script>

<style lang='less'>
  .cashierdiaryTable {
    color: #333333;
    .ct_wrapper {
      width: 1181px;
      display: flex;
      &-panel {
        margin-top: 48px;
      }
      &-table {
        width: 1032px;
        &-btnGroup {
          text-align: center;
          margin-top: 25px;
        }
        &-publicPadding {
          padding: 0 30px;
        }
        &-content {
          box-shadow: 0px 0px 18px 0px #E8E8E8;
          border-radius: 5px;
          background-color: #fff;
          padding: 25px 0px;
          margin-top: 10px;
          position: relative;
          &-footer {
            margin-top: 18px;
            &-num {
              color: #FF6010;
              font-size: 24px;
            }
            &-unit {
              color: #FF6010;
            }
          }
          &-main {
            margin-top: 15px;
            border: 1px solid #666666;
            &-row {
              border-bottom: 1px solid #CCCCCC;
              &:last-child {
                border-bottom: none;
              }
              &-td {
                display: flex;
                align-items: center;
                &-label {
                  padding: 6px 10px;
                  width: 100px;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  box-sizing: border-box;
                  border-right:1px solid #CCCCCC;
                  border-left:1px solid #CCCCCC;
                  &-isStuff {
                    color: #FF6010;
                    margin-right: 2px;
                    font-weight: 600;
                  }
                }
                &-value {
                  flex: 1;
                  box-sizing: border-box;
                  padding: 6px 8px;
                }

              }
            }
          }
          &-select {

          }
          &-tab {
          }
        }
        &-header {
          text-align: center;
          position: relative;
          &-close {
            position: absolute;
            font-size: 20px;
            font-weight: 600;
            right: 0;
            top: -30px;
          }
          &-title {
            color: #333;
            margin-right: 8px;
            font-size: 26px;
          }
          &-number {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            i {
              display: inline-block;
              width: 25px;
              height: 25px;
              cursor: pointer;
            }
            &-center {
              padding: 0 18px;
              display: inline-block;
              font-size: 18px;
              font-family: STSongti-SC-Regular, STSongti-SC;
            }
            &-left {
              background: url(/static/btn/before_n.png) no-repeat center;
            }
            &-right {
              background: url(/static/btn/after_d.png) no-repeat center;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/index.vue